module.exports = "<div class=resource-progress-outer> <div class=resource-progress-container> <div class=resource-progress-inner> </div> </div> </div>";


//////////////////
// WEBPACK FOOTER
// ./src/components/resourceProgress/html/resourceProgressContainer.html
// module id = 1168
// module chunks = 1